import { render } from "./CertificateOfComplianceTemplateExternal.vue?vue&type=template&id=e5efda02&scoped=true&ts=true"
import script from "./CertificateOfComplianceTemplateExternal.vue?vue&type=script&lang=ts"
export * from "./CertificateOfComplianceTemplateExternal.vue?vue&type=script&lang=ts"

import "./CertificateOfComplianceTemplateExternal.vue?vue&type=style&index=0&id=e5efda02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5efda02"]])

export default __exports__